import React, { useEffect, useState } from "react";
import TabsNavbar from "../../Common/TabsNavBar/TabsNavbar";
import { useTranslation } from "react-i18next";
import Button from "../../Common/FormElements/Button/Button";
import NewProspectForms from "./NewProspectForms";
import { useDispatch, useSelector } from "react-redux";
import {
  actionsForm,
  billingAddressForm,
  deliveryAddressForm,
  interlocutorForm,
  noteForm,
  prospectForm,
} from "./data";
import {
  createUpdateProspect,
  getCurrentProspect,
} from "../../../REDUX/actions/prospects";
import { closeRightModal } from "../../../REDUX/actions/rightModal";
import { isDefined } from "../../../Utils";
import { getFavorites, resetFavorites } from "../../../REDUX/actions/favorites";
import { Spinner } from "react-bootstrap";

const NewProspectModal = ({ id }) => {
  const TABS = [
    "Informations",
    "Note",
    "Interlocutors",
    "Pipeline action",
    "Location",
    "Addresses",
    "Comments",
  ];
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const {
    createUpdateProspectLoading: loading,
    currentProspectLoading,
    currentProspect,
  } = useSelector((state) => state?.prospectsReducer);
  const { favorites } = useSelector((state) => state.favoriteReducer);
  const [activeTab, setActiveTab] = useState(TABS[0]);
  const [invalidFields, setInvalidFields] = useState([]);
  const [customErrors, setCustomErrors] = useState({});
  const [disabled, setDisabled] = useState(true);
  const [deletedInterlocutors, setDeletedInterlocutors] = useState([]);
  const [forms, setForms] = useState({
    infos: {},
    addresses: {
      billing: {},
      delivery: {},
    },
    note: {},
    interlocutors: [],
    actions: [],
    comments: {},
    geoEntity: {},
  });

  if (favorites?.length > 0) {
    TABS.push("Favorites");
  }

  const checkFormValidation = () => {
    const updatedInvalidFields = [];
    prospectForm?.forEach(({ name, required }) => {
      if (required) {
        if (
          forms.infos[name] === undefined ||
          forms.infos[name] === null ||
          !String(forms.infos[name])?.trim()?.length > 0
        ) {
          updatedInvalidFields.push(name);
        }
      }
    });
    if (updatedInvalidFields?.length > 0) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
    setInvalidFields(updatedInvalidFields);
  };

  const handleClick = () => {
    const phoneNumberPattern = /^(\+|\d{1,4})\s?(\d\s?){5,}$/;
    if (!forms.infos.phoneNumber.match(phoneNumberPattern)) {
      setCustomErrors({
        ...customErrors,
        phoneNumber: "phoneNumberError",
      });

      return;
    }
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!forms.infos.email.match(emailPattern)) {
      setCustomErrors({
        ...customErrors,
        email: "emailError",
      });
      return;
    }
    dispatch(
      createUpdateProspect(
        { ...forms },
        currentProspect?.id,
        deletedInterlocutors,
        () => dispatch(closeRightModal()),
        t,
      ),
    );
  };

  useEffect(() => {
    setForms((currState) => {
      const updatedFormData = { ...currState };
      updatedFormData.actions = currentProspect?.attributes?.actions?.data?.map(
        (action) => {
          return actionsForm.reduce(
            (acc, { name }) => {
              acc[name] = action?.attributes[name];
              return acc;
            },
            {
              id: action?.id,
              status: action?.attributes?.status,
              isReminder: action?.attributes?.isReminder,
            },
          );
        },
      );
      updatedFormData.interlocutors =
        currentProspect?.attributes?.interlocutors?.data?.map((inter) => {
          return interlocutorForm.reduce(
            (acc, { name }) => {
              acc[name] = inter?.attributes[name];
              return acc;
            },
            { id: inter?.id, photo: inter?.attributes?.photo?.data },
          );
        });

      updatedFormData.geoEntity = {
        markers:
          currentProspect?.attributes?.geoEntity?.data?.attributes?.markers,
      };

      noteForm.forEach(({ name }) => {
        updatedFormData.note[name] =
          currentProspect?.attributes?.note?.data?.attributes[name];
      });
      prospectForm.forEach(({ name, type }) => {
        if (type === "multiSelect") {
          updatedFormData.infos[name] = currentProspect?.attributes[
            name
          ]?.data?.map(({ id }) => id);
        } else {
          if (name === "business_affiliate") {
            updatedFormData.infos[name] =
              currentProspect?.attributes?.business_affiliate?.data?.id;
          } else if (name === "spaMarques") {
            updatedFormData.infos[name] =
              currentProspect?.attributes?.spaMarques?.data?.map(
                (marque) => marque?.id,
              );
          } else {
            updatedFormData.infos[name] = currentProspect?.attributes[name];
          }
        }
      });
      currentProspect?.attributes?.delivery_addresses?.data?.length > 0 &&
        deliveryAddressForm.forEach(({ name, type }) => {
          if (type === "select") {
            updatedFormData.addresses.delivery[name] = {
              name: currentProspect?.attributes?.delivery_addresses?.data[0]
                ?.attributes[name]?.data?.attributes?.name,
              code: currentProspect?.attributes?.delivery_addresses?.data[0]
                ?.attributes[name]?.data?.id,
            };
          } else {
            updatedFormData.addresses.delivery[name] =
              currentProspect?.attributes?.delivery_addresses?.data[0]?.attributes[
                name
              ];
          }
        });

      currentProspect?.attributes?.billingAddress?.data?.length > 0 &&
        billingAddressForm.forEach(({ name, type }) => {
          if (type === "select") {
            updatedFormData.addresses.billing[name] = {
              name: currentProspect?.attributes?.billingAddress?.data[0]
                ?.attributes[name]?.data?.attributes?.name,
              code: currentProspect?.attributes?.billingAddress?.data[0]
                ?.attributes[name]?.data?.id,
            };
          } else {
            updatedFormData.addresses.billing[name] =
              currentProspect?.attributes?.billingAddress?.data[0]?.attributes[
                name
              ];
          }
        });

      updatedFormData.affiliate = {
        name:
          currentProspect?.attributes?.business_affiliate?.data?.attributes
            ?.company ?? "",
        code: currentProspect?.attributes?.business_affiliate?.data?.id,
      };

      return updatedFormData;
    });
  }, [currentProspect]);

  useEffect(() => {
    checkFormValidation();
  }, [forms]);

  useEffect(() => {
    const controller = new AbortController();
    dispatch(getCurrentProspect(id, controller.signal));

    return () => {
      controller.abort();
      dispatch({ type: "CLEAR_CURRENT_PROSPECT" });
    };
  }, [id, dispatch]);

  useEffect(() => {
    if (!isDefined(id)) return;
    const controller = new AbortController();

    // dispatch(getFavorites(id, "prospect"));
    dispatch(getFavorites(id, "prospect", controller.signal));

    return () => {
      controller.abort();
      dispatch(resetFavorites());
    };
  }, [id, dispatch]);

  return (
    <div className="newRevendeur d-flex flex-column justify-content-between h100 min-w-1110px position-relative">
      {(loading || currentProspectLoading) && (
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-50 z-9999 d-flex align-items-center justify-content-center">
          <Spinner />
        </div>
      )}
      <div className="flex-1 d-flex flex-column">
        <div className="alignH align-items-end">
          <h2 className={`sBold f25 quickSand text-blue ${"px-5"} mb-5`}>
            {id ? t("Modify the prospect") : t("Add a prospect")}
          </h2>
        </div>
        <TabsNavbar
          tabs={TABS}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          className={TABS?.length > 5 ? "gap-3" : "gap-5"}
          disabledIndexes={isDefined(id) ? [] : [3, 4, 5, 6]}
        />
        <NewProspectForms
          currentStatus={currentProspect?.attributes?.status}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          forms={forms}
          setForms={setForms}
          customErrors={customErrors}
          updateDeletedInterlocutors={setDeletedInterlocutors}
        />
        {activeTab !== "Addresses" && activeTab !== "Comments" && (
          <div className="buttonsContainer d-flex justify-content-center mt-auto">
            <Button
              variant="outline"
              className="me-4"
              onClick={() => dispatch(closeRightModal())}
            >
              {t("Cancel")}
            </Button>
            <Button
              // loading={loading}
              disabled={disabled}
              onClick={loading ? undefined : handleClick}
            >
              {t("Save")}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewProspectModal;
